import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "buy-quantity-select"
};
var _hoisted_2 = {
  class: "num-title"
};
var _hoisted_3 = {
  class: "buy-quantity-stepper"
};
var _hoisted_4 = {
  class: "tip-quantity"
};
var _hoisted_5 = {
  key: 0,
  class: "error-text"
};
var _hoisted_6 = {
  class: "tip-quantity"
};
var _hoisted_7 = {
  key: 0,
  class: "error-text"
};
var _hoisted_8 = {
  class: "tip-quantity-limit"
};
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { Bridge } from '@/utils/bridge';
var DEFAULT_MIN_INVENTORY_VALUE = 10;
export default {
  __name: 'BuyQuantity',
  props: {
    asinDetails: {
      type: Object
    },
    isOverQuantityLimit: {
      type: Boolean
    },
    quantity: {
      type: Number
    }
  },
  emits: ['update:quantity', 'quantityChange'],
  setup(__props, {
    emit: emits
  }) {
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var minAsinInventoryValue = ref(DEFAULT_MIN_INVENTORY_VALUE);
    var quantityNum = computed({
      get: () => props.quantity,
      set: val => {
        emits('update:quantity', val);
      }
    });
    var changeQuantity = () => {
      emits('quantityChange');
    };
    var getMinAsinInventoryValue = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _appConfig$constants$, _appConfig$constants$2;
        var appConfig;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Bridge.callFnVal('getAppConfig', {});
            case 2:
              appConfig = _context.sent;
              minAsinInventoryValue.value = (_appConfig$constants$ = appConfig === null || appConfig === void 0 ? void 0 : (_appConfig$constants$2 = appConfig[constants.ENUM_APP_CONFIG_TYPE.SETTING_PAGE]) === null || _appConfig$constants$2 === void 0 ? void 0 : _appConfig$constants$2.asinInventoryRemind) !== null && _appConfig$constants$ !== void 0 ? _appConfig$constants$ : DEFAULT_MIN_INVENTORY_VALUE;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getMinAsinInventoryValue() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(() => {
      getMinAsinInventoryValue();
    });
    return (_ctx, _cache) => {
      var _component_van_stepper = _resolveComponent("van-stepper");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('common.COUNT')), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [__props.asinDetails.stockOnHand < minAsinInventoryValue.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('modules.checkout.BUY_NOW_OR_MISS_OUT', {
        TOTAL: __props.asinDetails.stockOnHand
      })), 1)) : _createCommentVNode("", true)]), _createVNode(_component_van_stepper, {
        modelValue: quantityNum.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => quantityNum.value = $event),
        onChange: changeQuantity,
        theme: "round",
        "disable-input": "",
        max: __props.asinDetails.stockOnHand
      }, null, 8, ["modelValue", "max"])])]), _createElementVNode("div", _hoisted_6, [__props.isOverQuantityLimit ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('modules.checkout.ALREADY_AUTOMATIC_PURCHASE_RESTRICTION')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [__props.isOverQuantityLimit ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "small-btn",
        onClick: changeQuantity
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('button.CONFIRM')), 1)])) : _createCommentVNode("", true)])]);
    };
  }
};